import React, { useState, useEffect, useRef } from 'react';
import FilterComponent from './FilterComponent';
import UserPopup from './UserPopup';
import CategoryComponent from './CategoryComponent';
import ProductComponent from './ProductComponent';
import { Grid, Paper, Typography, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert } from '@mui/material';
// import nmaispeloImage from './n+p-logo.jpeg';
import nmaispeloImage from './logo1.jpeg';
import errorImage from './error.svg';
import CartComponent from './CartComponent';
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import PrintIcon from '@mui/icons-material/Print';
import html2canvas from 'html2canvas';

const POSComponent = ({ data, POS_PASSWORD, username, password, token }) => {
    const [selectedFilter, setSelectedFilter] = useState({ id: '', name: '' });
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [total, setTotal] = useState(0);
    const [orientation, setOrientation] = useState('');
    const [authorized, setAuthorized] = useState(false);
    const [openDialog, setOpenDialog] = useState(true);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [elevation, setElevation] = useState(3);

    useEffect(() => {
        function handleOrientationChange() {
            const isPortrait = window.innerHeight > window.innerWidth;
            setOrientation(isPortrait ? 'portrait' : 'landscape');
        }
        handleOrientationChange();
        window.addEventListener('resize', handleOrientationChange);
        return () => {
            window.removeEventListener('resize', handleOrientationChange);
        };
    }, []);

    useEffect(() => {
        setSelectedFilter({ id: '', name: '' });
        setCategories([]);
    }, []);

    const filters = data?.filters ?? [];

    const setCategoriesForSelectedFilter = (filterId) => {
        const selectedFilterObject = filters.find((filter) => filter.id === filterId);
        if (selectedFilterObject) {
            setCategories(selectedFilterObject.categories || []);
        } else {
            setCategories([]);
        }
    };

    const onSelectFilter = (filterId) => {
        const filterObject = filters.find((filter) => filter.id === filterId);
        if (filterObject) {
            setSelectedFilter({ id: filterId, name: filterObject.name });
            console.log(selectedFilter)
            setSelectedCategory(null);
            setCategoriesForSelectedFilter(filterId);
        } else {
            setSelectedFilter({ id: '', name: '' });
            setSelectedCategory(null);
            setCategories([]);
        }
    };

    const onSelectCategory = (categoryId) => {
        setSelectedCategory(categoryId);
        const category = categories.find((cat) => cat.id === categoryId);
        if (category) {
            const products = category.products.map((product) => ({
                ...product,
                price: product.price10x != null ? parseFloat(product.price10x) : null,
            }));
            console.log("Esse é os product: ", products)
            setSelectedProducts(products || []);
        } else {
            setSelectedProducts([]);
        }
    };

    const addToCart = (product) => {
        const existingItemIndex = cart.findIndex((item) => item.product.id === product.id);
        console.log(product.valor_maximo)
        if (existingItemIndex !== -1) {
            const updatedCart = [...cart];
            updatedCart[existingItemIndex].quantity++;
            setCart(updatedCart);
            updateTotal(product.price10x, 1);
        } else {
            const newCart = [...cart, { id: cart.length + 1, product, quantity: 1 }];
            setCart(newCart);
            updateTotal(product.price10x, 1);
        }
        setSelectedCategory(null);
    };

    const updateTotal = (priceChange, quantityChange) => {
        const newTotal = total + priceChange * quantityChange;
        setTotal(newTotal);
    };

    const cartRef = useRef(null);

    const handleTakeScreenshot = () => {
        if (elevation === 3) {
            setElevation(0);
        }

        if (elevation === 0) {
            const targetElement = document.getElementById('screenshot-print-target');

            const previousStyle = targetElement.style.boxShadow;

            targetElement.style.boxShadow = 'none !important';

            html2canvas(targetElement)
                .then(canvas => {
                    const imageUrl = canvas.toDataURL();

                    const currentDate = new Date();
                    const fileName = `screenshot_${currentDate.getFullYear()}${(currentDate.getMonth() + 1).toString().padStart(2, '0')}${currentDate.getDate().toString().padStart(2, '0')}_${currentDate.getHours().toString().padStart(2, '0')}${currentDate.getMinutes().toString().padStart(2, '0')}${currentDate.getSeconds().toString().padStart(2, '0')}.png`;

                    const link = document.createElement('a');
                    link.href = imageUrl;
                    link.download = fileName;

                    link.click()
                    // setElevation(3)

                    targetElement.style.boxShadow = previousStyle;

                })
                .catch(error => {
                    console.error('Erro ao capturar a tela:', error);

                    targetElement.style.boxShadow = previousStyle;
                });
        }
    };

    const printCart = () => {
        const printWindow = window.open('', '_blank', 'width=800,height=1000');

        if (!printWindow) {
            alert('Por favor, permita pop-ups para imprimir.');
            return;
        }

        const receiptHTML = `
        <!DOCTYPE html>
        <html lang="pt-BR">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Não+Pelo - Pedido</title>
            
            <style>
            @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                body {
                    font-family: 'Bebas Neue', sans-serif;
                    background: white;
                }

                @media print {
                    @page {
                        size: A4;
                        margin: 0;
                    }
                    body {
                        print-color-adjust: exact;
                        -webkit-print-color-adjust: exact;
                    }
                }

                .elegant-print {
                    width: 210mm;
                    min-height: 297mm;
                    margin: 0 auto;
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    color: #2d3436;
                    position: relative;
                    overflow: hidden;
                }

                .elegant-print::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 300px;
                    height: 300px;
                    background: radial-gradient(circle, rgba(213, 169, 160, 0.1) 0%, transparent 70%);
                    border-radius: 50%;
                }

                .elegant-print::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 400px;
                    height: 400px;
                    background: radial-gradient(circle, rgba(140, 196, 197, 0.08) 0%, transparent 70%);
                    border-radius: 50%;
                }

                .print-content {
                    position: relative;
                    z-index: 1;
                    padding: 50px 60px;
                }

                .print-header {
                    text-align: center;
                    margin-bottom: 50px;
                    padding-bottom: 30px;
                    border-bottom: 2px solid rgb(143, 212, 0);
                    position: relative;
                }

                .print-header::after {
                    content: '✦';
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: white;
                    padding: 0 15px;
                    color: rgb(143, 212, 0);
                    font-size: 18px;
                }

                .company-logo {
                    max-width: 200px;
                    max-height: 100px;
                    height: auto;
                    margin: 0 auto 20px auto;
                    display: block;
                    object-fit: contain;
                }

                .company-name {
                    font-size: 42px;
                    font-weight: 700;
                    color: #2d3436;
                    margin: 0 0 8px 0;
                    letter-spacing: 2px;
                }


                .info-value {
                    font-size: 20px;
                    color: #2d3436;
                    font-weight: 500;
                    text-align: center;
                    margin-bottom: 20px;
                    font-family: 'Arial', sans-serif;
                    font-style: italic;
                }

                .date-info-value {
                    font-size: 13px;
                    margin-top: 20px;
                    color: #2d3436;
                    font-weight: 500;
                    text-align: center;
                }

                .items-section {
                    margin-bottom: 40px;
                }

                .section-title {
                    font-size: 24px;
                    color: #2d3436;
                    margin-bottom: 25px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #e1e8ed;
                }

                .items-table {
                    width: 100%;
                    border-collapse: separate;
                    border-spacing: 0;
                }

                .items-table thead th {
                    // background: linear-gradient(135deg, #d5a9a0 0%, #c99b92 100%);
                    color: white;
                    padding: 15px 20px;
                    text-align: left;
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-weight: 600;
                }

                .items-table thead th:first-child {
                    border-radius: 8px 0 0 0;
                }

                .items-table thead th:last-child {
                    border-radius: 0 8px 0 0;
                    text-align: right;
                }

                .items-table tbody tr:nth-child(even) {
                    background: rgba(140, 196, 197, 0.03);
                }

                .items-table tbody td {
                    padding: 18px 20px;
                    border-bottom: 1px solid #e1e8ed;
                }

                .item-name {
                    font-weight: 500;
                    color: #2d3436;
                    font-size: 14px;
                }

                .item-description {
                    font-size: 11px;
                    color: #636e72;
                    margin-top: 3px;
                }

                .item-quantity {
                    text-align: center;
                    color: #636e72;
                    font-size: 13px;
                }

                .item-price {
                    text-align: right;
                    color: #2d3436;
                    font-weight: 500;
                    font-size: 14px;
                }

                .totals-section {
                    margin-top: 30px;
                    padding: 25px 30px;
                    background: white;
                    border-radius: 10px;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
                }

                .total-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 12px 0;
                    font-size: 14px;
                    color: #636e72;
                }

                .total-row.subtotal {
                    border-bottom: 1px solid #e1e8ed;
                }

                .total-row.grand-total {
                    margin-top: 15px;
                    padding-top: 20px;
                    border-top: 2px solid rgb(33, 46, 36);
                    font-size: 20px;
                    font-weight: 600;
                    color: #2d3436;
                }

                .total-row.grand-total .amount {
                    color: rgb(143, 212, 0);
                }

                .print-footer {
                    margin-top: 60px;
                    text-align: center;
                    padding-top: 30px;
                    border-top: 1px solid #e1e8ed;
                }

                .thank-you {
                    font-size: 22px;
                    color: rgb(143, 212, 0);
                    margin-bottom: 15px;
                    font-style: italic;
                }

                .social-info {
                    font-size: 11px;
                    color: #636e72;
                    margin-top: 15px;
                }

                .divider {
                    display: inline-block;
                    margin: 0 10px;
                    color: rgb(143, 212, 0);
                }
            </style>
        </head>
        <body>
            <div class="elegant-print">
                <div class="print-content">
                    <div class="print-header">
                        <img src="${nmaispeloImage}" alt="Não+Pelo Logo" class="company-logo" onerror="this.style.display='none'" />
                    </div>

                            <div class="info-value">
                                Plano Personalizado
                            </div>

                    <div class="items-section">
                        
                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th style="width: 10%; text-align: center">Código</th>
                                    <th style="width: 50%">Item</th>
                                    <th style="width: 10%; text-align: center">Quantidade</th>
                                    <th style="width: 15%; text-align: center">Preço Unit.</th>
                                    <th style="width: 15%; text-align: right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${cart.map(item => `
                                    <tr>
                                        <td>
                                            <div class="item-name">
                                                ${item.product.group || '****'}
                                            </div>
                                        </td>
                                        <td>
                                            <div class="item-name">
                                                ${item.product.name || item.description || 'Produto/Serviço'}
                                            </div>
                                        </td>
                                        <td class="item-quantity">
                                            ${item.quantity}
                                        </td>
                                        <td style="text-align: center; color: #636e72; font-size: 13px">
                                            R$ ${(item.product.price).toFixed(2)}
                                        </td>
                                        <td class="item-price">
                                            R$ ${((item.quantity) * (item.product.price)).toFixed(2)}
                                        </td>
                                    </tr>
                                `).join('')}
                            </tbody>
                        </table>
                    </div>

                    <div class="totals-section">
                        <div class="total-row grand-total">
                            <span>Total</span>
                            <span class="amount">R$ ${total.toFixed(2)}</span>
                        </div>
                    </div>

                    <div class="date-info-value">
                        ${new Date().toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
        })}
                    </div>

                    <div class="print-footer">
                        <div class="thank-you">Não+Pelo - O Poder da Liberdade!</div>
                        <div class="social-info">
                            <span class="divider">•</span> www.naomaispelo.com.br <span class="divider">•</span>
                        </div>
                    </div>
                </div>
            </div>

            <script>
                window.onload = function() {
                    setTimeout(function() {
                        window.print();
                    }, 500);
                };
            </script>
        </body>
        </html>
    `;

        printWindow.document.write(receiptHTML);
        printWindow.document.close();
    };

    return (
        <div style={{ paddingTop: '2rem', minHeight: '100vh', position: 'relative' }}>
            <div style={{
                display: 'flex',
                flexDirection: orientation === 'portrait' ? 'column' : 'row',
                alignItems: 'center',
                marginBottom: '1rem',
                justifyContent: 'start',
                gap: orientation === 'portrait' ? '1rem' : '3rem',
                paddingLeft: '3rem',
            }}>
                <img
                    src={nmaispeloImage}
                    alt="Imagem antes dos filtros"
                    style={{
                        width: orientation === 'portrait' ? '50%' : '8rem',
                        marginBottom: orientation === 'portrait' ? '1rem' : '0',
                        transition: 'width 0.5s ease-in-out',
                    }}
                />
                <FilterComponent filters={filters} selectedFilter={selectedFilter} onSelectFilter={onSelectFilter} />
                <div style={{ position: 'absolute', top: '1rem', right: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button onClick={handleTakeScreenshot} style={{ color: 'black' }}> <CameraAltIcon /> </Button>
                    <Button onClick={printCart} style={{ color: "black" }}> <PrintIcon /> </Button>

                </div>
            </div>

            <Grid container spacing={2} style={{ marginTop: 16 }}>
                <Grid item xs={orientation === 'portrait' ? 12 : 6}>
                    <Paper elevation={3} style={{ padding: '37px 16px 0 16px', height: '100%' }}>
                        {filters.length === 0 && (
                            <div style={{ textAlign: 'center' }}>
                                <img src={errorImage} alt="Descrição da Imagem" style={{ width: '400px', height: '350px' }} />
                                <Alert severity='error' style={{ margin: '0 auto' }}>O Sistema parece não estar funcionando corretamente. Contate o administrador do sistema!</Alert>
                            </div>
                        )}

                        {selectedCategory ? (
                            <>
                                <div style={{ position: 'relative', height: '100%' }}>
                                    <ProductComponent products={selectedProducts} onSelectProduct={addToCart} selectedFilter={selectedFilter.id} />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setSelectedCategory(null)}
                                        style={{
                                            marginBottom: 16,
                                            backgroundColor: '#8fd400',
                                            marginTop: 16,
                                            position: 'absolute',
                                            bottom: 0,
                                            boxShadow: 'none', // Remover qualquer sombra adicional
                                        }}
                                        disableElevation // Desativa a elevação
                                    >
                                        Voltar
                                    </Button>
                                </div>
                            </>
                        ) : selectedFilter === 1 ? (
                            <div>
                                {/* <img src={masculinoImage} alt="Imagem Masculino" style={{ height: '100%' }} /> */}
                                <CategoryComponent categories={categories} onSelectCategory={onSelectCategory} />
                            </div>
                        ) : (
                            <CategoryComponent categories={categories} onSelectCategory={onSelectCategory} />
                        )}
                    </Paper>
                </Grid>
                <Grid item xs={orientation === 'portrait' ? 12 : 6}>
                    <div ref={cartRef} id="screenshot-print-target" style={{ height: '100%' }}>
                        <CartComponent
                            cart={cart}
                            total={total}
                            setCart={setCart}
                            setTotal={setTotal}
                            elevation={elevation}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default POSComponent;
